import * as React from 'react';
import moment from 'moment';

export interface MiniCalendarGridItemViewProps {
    click?: () => void;
    handleKeyEvent: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
    day: number;
    moment: moment.Moment;
    buttonRef: React.RefObject<HTMLButtonElement>;
    sameMonth: boolean;
    hasEvents: boolean;
    today: boolean;
    isCurrentDate: boolean;
}



/**
 * A grid-item in the mini-calendar. Has various classNames based on the props.
 */
export const MiniCalendarGridItemView: React.FunctionComponent<MiniCalendarGridItemViewProps> = props => {
    let liClassName = !props.sameMonth
        ? "mini-cal-day-inactive"
        : "mini-cal-day";
    liClassName += (props.sameMonth && !props.click) || (props.sameMonth && !props.hasEvents)
        ? " mini-cal-day-disabled"
        : "";
    if (props.today) {
        liClassName += " mini-cal-day-today";
    }
    if (props.click && props.sameMonth) {
        return (
            <li className={liClassName}>
                <button className="mini-cal-day-btn" disabled={!props.hasEvents} type="button" ref={props.buttonRef} onKeyDown={props.handleKeyEvent} onClick={props.click} data-currentdate={props.isCurrentDate}>
                    <span className="visually-hidden">
                        {`${props.moment.format('dddd, MMMM')} `}
                    </span>
                    {props.day}
                </button>
            </li>
        );
    } else {
        return (
            <li className={liClassName}>
             <button className="mini-cal-day-btn" disabled={!props.hasEvents} type="button" ref={props.buttonRef} onKeyDown={props.handleKeyEvent} onClick={props.click} data-currentdate={props.isCurrentDate}>
                    <span className="visually-hidden">
                        {`${props.moment.format('dddd, MMMM')} `}
                    </span>
                 
                    {props.day}
                </button>
            </li>
        );
    }
}
